module.exports = __webpack_public_path__ + "img/thumb_09.12fc6923.jpg";